var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFactura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1117 781",
    style: {
      enableBackground: "new 0 0 1117 781"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F6F7FB;}\n\t.st1{fill:#E35F21;}\n\t.st2{fill:none;stroke:#221F20;stroke-miterlimit:10;}\n\t.st3{fill:#221F20;}\n\t.st4{font-family:'Ubuntu-Medium';}\n\t.st5{font-size:13px;}\n\t.st6{font-family:'Ubuntu-Regular';}\n\t.st7{font-size:15px;}\n\t.st8{font-size:16px;}\n\t.st9{fill:#FFFFFF;}\n\t.st10{font-size:11px;}\n\t.st11{font-size:12px;}\n\t.st12{font-size:10px;}\n\t.st13{font-size:14px;}\n\t.st14{font-size:18px;}\n\t.st15{font-size:6.996px;}\n\t.st16{font-family:'Ubuntu-Italic';}\n\t.st17{font-family:'Ubuntu-Bold';}\n\t.st18{font-size:9.328px;}\n\t.st19{font-size:17px;}\n\t.st20{fill:none;stroke:#221F20;stroke-width:2;stroke-miterlimit:10;}\n\t.st21{fill-rule:evenodd;clip-rule:evenodd;fill:#E06D3A;}\n\t.st22{fill-rule:evenodd;clip-rule:evenodd;fill:#32324C;}\n\t.st23{fill:#32324C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 1117,
    height: 781
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.6,
    y: 95.9,
    className: "st1",
    width: 102.5,
    height: 24.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.9,
    y: 170.1,
    className: "st2",
    width: 688.6,
    height: 428.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 749.7,
    y: 170.1,
    className: "st2",
    width: 317,
    height: 228.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 751,
    y1: 213.7,
    x2: 1065.8,
    y2: 213.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 751,
    y1: 236.6,
    x2: 1065.8,
    y2: 236.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 751,
    y1: 259.6,
    x2: 1065.8,
    y2: 259.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 751,
    y1: 282.5,
    x2: 1065.8,
    y2: 282.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 751,
    y1: 305.5,
    x2: 1065.8,
    y2: 305.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 751,
    y1: 328.4,
    x2: 1065.8,
    y2: 328.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 751,
    y1: 351.3,
    x2: 1065.8,
    y2: 351.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 751,
    y1: 374.3,
    x2: 1065.8,
    y2: 374.3
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 46.9,
    y1: 213.7,
    x2: 735.5,
    y2: 213.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 533.6,
    y1: 185.3,
    x2: 657,
    y2: 185.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 46.9,
    y1: 572.3,
    x2: 735.5,
    y2: 572.3
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 215.6219 40.4432)",
    className: "st3 st4 st5"
  }, "Beneficiar"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 277.3619 40.4432)",
    className: "st3 st6 st5"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 283.3619 40.4432)",
    className: "st3 st6 st7"
  }, " A.C.C 205/89"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 49.6225 62.9166)",
    className: "st3 st6 st5"
  }, "Document de plat\u0103"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 48.8901 89.1265)",
    className: "st3 st6 st5"
  }, "Pl\u0103titor    "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 105.5701 89.1265)",
    className: "st3 st6 st8"
  }, "Profadmin G."), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 48.2958 113.8313)",
    className: "st3 st6 st5"
  }, "Cod ID"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 104.8847 113.8313)",
    className: "st9 st4 st8"
  }, "299999999"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 48.2958 150.3842)",
    className: "st3 st4 st8"
  }, "Nicolae Testemi\u021Banu str., bl. 29G, ap.323"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 573.2924 150.6403)",
    className: "st3 st6 st8"
  }, "Suprafa\u021Ba"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 954.8062 150.88)",
    className: "st3 st6 st7"
  }, "Indicii contorului"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 831.2902 191.1904)",
    className: "st3 st6 st10"
  }, "Numarul"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 822.9002 204.3904)",
    className: "st3 st6 st10"
  }, "contorului"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 88.6126 187.0202)",
    className: "st3 st6 st11"
  }, "Tip"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 78.3526 201.4202)",
    className: "st3 st6 st11"
  }, "servicii"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 48.214 228.5933)",
    className: "st3 st6 st12"
  }, "Serv. de administrare"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 192.5596 231.283)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 192.5596 258.0403)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 192.5596 286.5492)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 192.5596 313.8016)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 192.5596 590.5897)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 506.4396 590.5897)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 568.476 590.5897)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 537.0031 624.1229)",
    className: "st3 st6 st13"
  }, "Avans (Lei)"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 475.4747 664.0607)",
    className: "st3 st6 st13"
  }, "Total spre plat\u0103 (Lei)"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 76.3827 714.7568)",
    className: "st3 st6 st13"
  }, "022-803-344"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 76.3827 733.7568)",
    className: "st3 st6 st13"
  }, "062-007-800"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 76.3827 752.7568)",
    className: "st3 st6 st13"
  }, "contact@profadmin.md"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 628.9048 590.5897)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 669.362 628.6246)",
    className: "st3 st4 st14"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 447.0476 590.5897)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 374.8971 590.5897)",
    className: "st3 st6 st11"
  }, "579.76"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 695.099 590.5897)",
    className: "st3 st6 st11"
  }, "579.76"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 651.1772 666.6507)",
    className: "st3 st4 st14"
  }, "579.76"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 293.9346 231.283)",
    className: "st3 st6 st11"
  }, "m"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 304.2666 227.2865)",
    className: "st3 st6 st15"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 293.9346 258.0403)",
    className: "st3 st6 st11"
  }, "m"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 304.2666 254.0443)",
    className: "st3 st6 st15"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 283.9487 286.5492)",
    className: "st3 st6 st11"
  }, "kWh"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 281.501 313.8016)",
    className: "st3 st6 st11"
  }, "pers."), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 329.2931 231.283)",
    className: "st3 st6 st11"
  }, "2.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 322.5255 258.0403)",
    className: "st3 st6 st11"
  }, "15.30"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 329.2931 286.5492)",
    className: "st3 st6 st11"
  }, "3.42"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 322.5255 313.8016)",
    className: "st3 st6 st11"
  }, "19.70"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 381.743 231.283)",
    className: "st3 st6 st11"
  }, "81.80"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 381.743 258.0403)",
    className: "st3 st6 st11"
  }, "61.20"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 374.975 286.5492)",
    className: "st3 st6 st11"
  }, "307.80"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 381.743 313.8016)",
    className: "st3 st6 st11"
  }, "19.70"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 700.6752 231.283)",
    className: "st3 st6 st11"
  }, "81.80"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 700.6752 258.0403)",
    className: "st3 st6 st11"
  }, "61.20"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 693.9072 286.5492)",
    className: "st3 st6 st11"
  }, "307.80"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 700.6752 313.8016)",
    className: "st3 st6 st11"
  }, "19.70"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 443.8184 231.283)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 443.8184 258.0403)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 443.8184 286.5492)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 443.8184 313.8016)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 628.7085 231.283)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 628.7085 258.0403)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 628.7085 286.5492)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 628.7085 313.8016)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 505.501 231.283)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 505.501 258.0403)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 505.501 286.5492)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 566.8683 231.283)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 566.8683 286.5492)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 505.501 313.8016)",
    className: "st3 st6 st11"
  }, "0.00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 230.5952 231.283)",
    className: "st3 st6 st11"
  }, "40.9000"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 230.8249 258.0403)",
    className: "st3 st6 st11"
  }, "4.00000"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 230.178 286.5492)",
    className: "st3 st6 st11"
  }, "90.0000"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 230.8153 313.8016)",
    className: "st3 st6 st11"
  }, "1.00000"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 49.9824 256.19)",
    className: "st3 st6 st12"
  }, "Apa potabila"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 51.0154 282.6682)",
    className: "st3 st6 st12"
  }, "Energia electrica"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 50.11 310.5746)",
    className: "st3 st6 st12"
  }, "Transportarea deseuri"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 76.2595 588.4278)",
    className: "st3 st16 st10"
  }, "Total"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 167.9416 187.176)",
    className: "st3 st6 st11"
  }, "Datorie"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 178.0916 201.576)",
    className: "st3 st6 st11"
  }, "(lei)"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 362.7434 187.176)",
    className: "st3 st6 st11"
  }, "Calculat"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 374.2534 201.576)",
    className: "st3 st6 st11"
  }, "(lei)"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 422.243 187.176)",
    className: "st3 st6 st11"
  }, "Recalcul"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 434.403 201.576)",
    className: "st3 st6 st11"
  }, "(lei)"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 227.1135 193.7731)",
    className: "st3 st6 st11"
  }, "Consum"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 284.771 193.7731)",
    className: "st3 st6 st11"
  }, "u.m."), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 320.5946 193.7731)",
    className: "st3 st6 st11"
  }, "Tarif"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 784.4104 191.1904)",
    className: "st3 st6 st10"
  }, "TIP"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 909.9778 191.1904)",
    className: "st3 st6 st10"
  }, "Valabil"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 908.3878 204.3904)",
    className: "st3 st6 st10"
  }, "p\xE2n\u0103 la"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 761.1248 191.1904)",
    className: "st3 st6 st10"
  }, "Nr."), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 758.8648 204.3904)",
    className: "st3 st6 st10"
  }, "ord"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 789.4035 231.7569)",
    className: "st3 st6 st10"
  }, "E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 788.7653 254.6557)",
    className: "st3 st6 st10"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 867.3163 231.7569)",
    className: "st3 st17 st10"
  }, "EE001"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 861.203 254.6557)",
    className: "st3 st17 st10"
  }, "157001"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 937.5458 231.7569)",
    className: "st3 st6 st10"
  }, "0.0"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 937.0643 254.6557)",
    className: "st3 st6 st10"
  }, "0.0"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 977.9498 231.7569)",
    className: "st3 st6 st10"
  }, "1620.0"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 983.8922 254.6557)",
    className: "st3 st6 st10"
  }, "173.0"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 763.0287 231.7569)",
    className: "st3 st6 st10"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 763.0287 254.6557)",
    className: "st3 st6 st10"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 985.11 191.1904)",
    className: "st3 st6 st10"
  }, "Indicii"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 960.04 204.3904)",
    className: "st3 st6 st10"
  }, "preceden\u0163i"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1028.9697 191.1904)",
    className: "st3 st6 st10"
  }, "Indicii"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1021.1397 204.3904)",
    className: "st3 st6 st10"
  }, "Curen\u0163i"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 789.7504 83.7799)",
    className: "st3 st6 st11"
  }, "Intermediar la decont\u0103ri"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 789.7504 101.7799)",
    className: "st3 st6 st7"
  }, "IBAN MD70ML000000002251328619"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 789.7504 119.7799)",
    className: "st3 st6 st7"
  }, "Cod fiscal 1018600049124"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 671.7054 150.6402)",
    className: "st3 st6 st8"
  }, "40.90 m"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 729.208 145.3119)",
    className: "st3 st6 st18"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 594.6265 69.2946)",
    className: "st3 st17 st19"
  }, "Februarie 2023"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 472.7065 88.4946)",
    className: "st3 st4 st8"
  }, "Termen de achitare 31 martie 2023"), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 780.2,
    y1: 398.6,
    x2: 780.2,
    y2: 170.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 155.9,
    y1: 598.8,
    x2: 155.9,
    y2: 170.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 220.8,
    y1: 598.8,
    x2: 220.8,
    y2: 170.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 277.4,
    y1: 598.8,
    x2: 277.4,
    y2: 170.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 312,
    y1: 598.8,
    x2: 312,
    y2: 170.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 356.9,
    y1: 598.8,
    x2: 356.9,
    y2: 170.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 415.9,
    y1: 598.8,
    x2: 415.9,
    y2: 170.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 474,
    y1: 598.8,
    x2: 474,
    y2: 170.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 533.7,
    y1: 598.8,
    x2: 533.7,
    y2: 170.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 657,
    y1: 598.8,
    x2: 657,
    y2: 170.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 595.3,
    y1: 598.8,
    x2: 595.3,
    y2: 185.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 804.4,
    y1: 398.6,
    x2: 804.4,
    y2: 170.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 903.2,
    y1: 398.6,
    x2: 903.2,
    y2: 170.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 957.8,
    y1: 398.6,
    x2: 957.8,
    y2: 170.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 1016.9,
    y1: 398.6,
    x2: 1016.9,
    y2: 170.1
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 481.3161 180.9363)",
    className: "st3 st6 st11"
  }, "Consum"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 484.9261 195.3363)",
    className: "st3 st6 st11"
  }, "comun"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 492.9061 209.7363)",
    className: "st3 st6 st11"
  }, "(lei)"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 680.0159 188.9403)",
    className: "st3 st6 st11"
  }, "Suma"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 684.5559 203.3403)",
    className: "st3 st6 st11"
  }, "(lei)"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 535.6708 196.0183)",
    className: "st3 st6 st10"
  }, "din bugetul"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 546.9208 209.2183)",
    className: "st3 st6 st10"
  }, "de stat"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 597.4911 196.0183)",
    className: "st3 st6 st10"
  }, "din bugetul"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 602.0711 209.2183)",
    className: "st3 st6 st10"
  }, "municipal"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 565.632 180.4328)",
    className: "st3 st6 st10"
  }, "Compensarea"), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M725.8,638.5H626c-4.8,0-8.7-3.9-8.7-8.7v-18.1c0-4.8,3.9-8.7,8.7-8.7h99.9c4.8,0,8.7,3.9,8.7,8.7v18.1 C734.5,634.6,730.6,638.5,725.8,638.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M725.8,678.2H626c-4.8,0-8.7-3.9-8.7-8.7v-18.1c0-4.8,3.9-8.7,8.7-8.7h99.9c4.8,0,8.7,3.9,8.7,8.7v18.1 C734.5,674.3,730.6,678.2,725.8,678.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.9,743.9l-8.5,6.7l-8.5-6.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.9,741.9h13c1.1,0,2,0.9,2,2v9c0,1.1-0.9,2-2,2h-13c-1.1,0-2-0.9-2-2v-9C50.9,742.8,51.8,741.9,52.9,741.9 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.4,702c0.5,0,0.8,0.3,0.8,0.8c0,0.9,0.2,1.9,0.5,2.8c0.1,0.2,0,0.5-0.2,0.8l-1.8,1.7c1.1,2.2,3,4,5.1,5.1 l1.7-1.7c0.2-0.2,0.3-0.2,0.5-0.2c0.1,0,0.2,0,0.3,0.1c0.8,0.3,1.8,0.5,2.8,0.5c0.5,0,0.8,0.3,0.8,0.8v2.7c0,0.5-0.3,0.8-0.8,0.8 c-7.3,0-13.2-5.9-13.2-13.2c0-0.5,0.3-0.8,0.8-0.8L55.4,702 M55.4,701h-2.7c-1,0-1.8,0.8-1.8,1.8c0,7.8,6.4,14.2,14.2,14.2 c1,0,1.8-0.8,1.8-1.8v-2.7c0-1-0.8-1.8-1.8-1.8c-0.9,0-1.7-0.1-2.4-0.4c-0.2-0.1-0.5-0.2-0.7-0.2c-0.4,0-0.9,0.2-1.2,0.5l-1.2,1.2 c-1.6-1-2.8-2.2-3.7-3.7l1.2-1.2l0.1-0.1l0.1-0.1c0.3-0.5,0.4-1.1,0.3-1.7c-0.3-0.8-0.4-1.7-0.4-2.5C57.1,701.8,56.4,701,55.4,701 L55.4,701z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "871,55.2 874,55.2 884.8,36.6 883.3,34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "893.6,17.9 905.2,38 908.1,38 896.5,17.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "881.8,17.9 883.1,20.3 884.6,22.8 886.1,25.4 887.6,27.9 893.4,38 896.3,38 889,25.4 887.6,22.8  886.1,20.3 884.7,17.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "875.9,17.9 877.2,20.3 878.7,22.8 880.2,25.4 881.7,27.9 883.1,30.5 884.6,33 887.5,38 890.4,38  886.1,30.5 883.1,25.4 881.7,22.8 880.2,20.3 878.8,17.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "887.7,17.9 889,20.3 890.5,22.8 899.3,38 902.2,38 892,20.3 890.6,17.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "880.3,28.9 865.1,55.2 868.1,55.2 881.8,31.5 881.8,31.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "877.4,23.8 859.2,55.2 862.2,55.2 878.8,26.4 878.8,26.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "853.3,55.2 856.3,55.2 875.9,21.3 875.9,21.2 874.4,18.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M887.8,40l-8.9,16.1h3l1.6-3h8.6l1,3h3.1L890.8,40H887.8L887.8,40z M888.8,42.9h0.3l2.3,7.7h-6.4L888.8,42.9 L888.8,42.9z M900,40l-1.8,16.1h6.7c1.2,0,2.3-0.2,3.3-0.6c1-0.4,1.9-0.9,2.7-1.6c0.5-0.5,1-1,1.5-1.7c0.4-0.6,0.8-1.3,1-2 c0.3-0.7,0.4-1.5,0.5-2.2c0.1-1.1,0-2.2-0.2-3.1c-0.3-0.9-0.7-1.8-1.3-2.5c-0.7-0.8-1.5-1.4-2.5-1.8c-1-0.4-2.1-0.7-3.3-0.7 L900,40L900,40z M906.3,42.6c0.8,0,1.6,0.1,2.2,0.4c0.6,0.3,1.2,0.6,1.6,1.1c0.4,0.5,0.7,1.1,0.9,1.7c0.2,0.7,0.2,1.4,0.1,2.2 c-0.1,0.8-0.3,1.6-0.6,2.2c-0.3,0.7-0.8,1.2-1.3,1.8c-0.5,0.5-1.1,0.8-1.8,1.1c-0.7,0.3-1.5,0.4-2.3,0.4h-3.8l1.2-10.9L906.3,42.6 L906.3,42.6z M917.2,40l-1.8,16.1h2.7l1.3-11.8h0.1l4.5,7.5h1l6.1-7.5h0.1L930,56.2h2.8l1.8-16.1h-3.1l-6.4,8l-4.8-8H917.2 L917.2,40z M940.1,40h-2.8l-1.8,16.1h2.8L940.1,40L940.1,40z M955,40l-1.3,11.6L945.5,40h-2.7l-1.8,16.1h2.8l1.3-11.6l8.2,11.6 h2.7l1.8-16.1H955L955,40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M809.3,45.4c0-0.7-0.1-1.3-0.3-1.9c-0.2-0.6-0.5-1.1-0.9-1.6c-0.3-0.4-0.8-0.8-1.2-1.1 c-0.5-0.3-1-0.5-1.5-0.7c-0.5-0.2-1.1-0.2-1.7-0.2h-7.4v15.2h2.8v-4.1h4.6c0.8,0,1.5-0.1,2.2-0.4c0.7-0.3,1.3-0.7,1.8-1.2 c0.5-0.5,0.9-1.1,1.2-1.7C809.2,46.9,809.3,46.2,809.3,45.4L809.3,45.4z M803.7,48.5H799v-6.1h4.5c0.5,0,0.9,0.1,1.3,0.3 c0.4,0.2,0.7,0.4,1,0.7c0.2,0.3,0.4,0.6,0.6,0.9s0.2,0.7,0.2,1.1c0,0.2,0,0.5-0.1,0.7c-0.1,0.2-0.2,0.5-0.3,0.7 c-0.1,0.2-0.2,0.5-0.4,0.7c-0.2,0.3-0.6,0.5-0.9,0.7C804.5,48.4,804.1,48.5,803.7,48.5L803.7,48.5z M824.5,45.4 c0-0.8-0.2-1.5-0.4-2.2s-0.7-1.2-1.2-1.8c-0.5-0.5-1.2-0.9-1.9-1.2c-0.7-0.3-1.5-0.4-2.2-0.4h-7.5v15.2h2.7v-4.1h4.7l2.5,4.1h3.1 c-0.3-0.5-0.6-1-0.9-1.5s-0.7-1.1-1-1.6c-0.3-0.5-0.6-1-0.9-1.5c0.4-0.2,0.8-0.4,1.2-0.7c0.3-0.3,0.6-0.6,0.9-0.9 c0.3-0.5,0.6-1,0.8-1.5C824.5,46.7,824.5,46.1,824.5,45.4L824.5,45.4z M814,42.4h4.7c0.5,0,0.9,0.1,1.3,0.3c0.4,0.2,0.7,0.4,1,0.8 c0.2,0.3,0.4,0.6,0.6,0.9c0.1,0.4,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1c-0.1,0.4-0.3,0.7-0.6,1c-0.2,0.3-0.6,0.5-0.9,0.7 c-0.4,0.2-0.8,0.2-1.2,0.2H814L814,42.4L814,42.4z M834.1,39.6c-0.8,0-1.6,0.1-2.3,0.3c-0.7,0.2-1.4,0.5-2,0.8 c-0.6,0.4-1.2,0.8-1.6,1.3c-0.7,0.7-1.2,1.5-1.6,2.5c-0.4,0.9-0.6,1.9-0.6,3c0,0.7,0.1,1.3,0.3,2c0.2,0.6,0.4,1.2,0.7,1.8 c0.3,0.6,0.7,1.1,1.1,1.5c0.5,0.5,1,0.9,1.6,1.3s1.3,0.7,2,0.9c0.7,0.2,1.5,0.3,2.3,0.3c1.2,0,2.3-0.2,3.3-0.6 c1-0.4,1.8-1,2.6-1.7c0.7-0.7,1.2-1.5,1.6-2.5c0.4-0.9,0.6-2,0.6-3c0-0.7-0.1-1.4-0.3-2.1c-0.2-0.7-0.4-1.3-0.8-1.9 c-0.3-0.6-0.8-1.1-1.2-1.6c-0.7-0.7-1.5-1.2-2.5-1.6C836.3,39.8,835.2,39.6,834.1,39.6L834.1,39.6z M828.7,47.5 c0-0.8,0.1-1.5,0.4-2.1c0.3-0.6,0.6-1.2,1-1.7c0.3-0.3,0.7-0.7,1.1-0.9c0.4-0.2,0.8-0.4,1.3-0.6c0.5-0.1,1-0.2,1.5-0.2 c0.7,0,1.4,0.2,2.1,0.4s1.2,0.7,1.7,1.2c0.4,0.5,0.8,1,1,1.7c0.3,0.7,0.4,1.4,0.4,2.2c0,0.8-0.1,1.5-0.4,2.1 c-0.2,0.6-0.6,1.2-1,1.7c-0.5,0.5-1.1,0.9-1.7,1.2c-0.7,0.3-1.4,0.4-2.2,0.4c-0.8,0-1.5-0.2-2.2-0.5c-0.7-0.3-1.2-0.7-1.7-1.2 c-0.5-0.5-0.8-1-1-1.7C828.9,48.9,828.7,48.2,828.7,47.5L828.7,47.5z M844.1,39.9v15.2h2.7v-6.3l6.3,0l1.5-2.5h-7.8v-3.8h10 l1.5-2.6L844.1,39.9L844.1,39.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M799.1,63.5l0.4,1.3h1.2l-1.5-4.9h-1.5l-1.5,4.9h1.1l0.3-1.3L799.1,63.5L799.1,63.5z M797.9,62.7l0.3-1 c0-0.1,0-0.2,0.1-0.3s0-0.2,0.1-0.3c0-0.1,0-0.2,0.1-0.3h0c0,0.1,0,0.2,0.1,0.3s0,0.2,0.1,0.3s0.1,0.2,0.1,0.3l0.3,1H797.9 L797.9,62.7z M803.2,64.8c0.1,0,0.3,0,0.5,0.1c0.2,0,0.5,0,0.7,0c0.3,0,0.6,0,0.9-0.1s0.5-0.1,0.8-0.2s0.4-0.2,0.6-0.3 c0.2-0.1,0.3-0.3,0.4-0.5s0.2-0.4,0.3-0.7s0.1-0.5,0.1-0.8c0-0.3,0-0.5-0.1-0.8c-0.1-0.2-0.2-0.4-0.3-0.6 c-0.1-0.2-0.3-0.3-0.4-0.5c-0.2-0.1-0.3-0.2-0.5-0.3s-0.4-0.1-0.7-0.2c-0.2,0-0.5-0.1-0.8-0.1c-0.2,0-0.4,0-0.5,0s-0.3,0-0.5,0 s-0.3,0-0.4,0.1V64.8L803.2,64.8z M804.3,60.7c0,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0.1,0.8,0.2c0.2,0.1,0.4,0.3,0.5,0.5 s0.2,0.5,0.2,0.8c0,0.4-0.1,0.7-0.2,1c-0.1,0.2-0.3,0.4-0.6,0.6c-0.2,0.1-0.5,0.2-0.9,0.2c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0 L804.3,60.7L804.3,60.7z M814.3,64.8h1.1l-0.3-4.9h-1.5l-0.5,1.6c-0.1,0.2-0.1,0.4-0.2,0.6c0,0.2-0.1,0.4-0.2,0.6 c0,0.2-0.1,0.4-0.1,0.6h0c0-0.3-0.1-0.6-0.2-0.9s-0.2-0.6-0.2-0.9l-0.5-1.6h-1.5l-0.3,4.9h1l0.1-1.9c0-0.2,0-0.4,0-0.7 c0-0.2,0-0.5,0-0.7s0-0.5,0-0.7h0c0,0.2,0.1,0.4,0.1,0.7c0,0.2,0.1,0.4,0.2,0.7s0.1,0.4,0.2,0.6l0.5,1.9h0.9l0.6-1.9 c0.1-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.1-0.4,0.2-0.7s0.1-0.4,0.2-0.6h0c0,0.2,0,0.5,0,0.7c0,0.2,0,0.5,0,0.7s0,0.4,0,0.6L814.3,64.8 L814.3,64.8z M818.1,59.9v4.9h1.1v-4.9H818.1L818.1,59.9z M823,64.8v-1.5c0-0.4,0-0.8,0-1.1c0-0.3,0-0.7,0-1h0 c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.2,0.2,0.4,0.3,0.5l1,1.9h1.2v-4.9h-1v1.4c0,0.4,0,0.7,0,1.1s0,0.7,0.1,1 h0c-0.1-0.2-0.2-0.4-0.2-0.6c-0.1-0.2-0.2-0.4-0.3-0.6s-0.2-0.4-0.3-0.5l-1-1.8H822v4.9H823L823,64.8z M828.8,59.9v4.9h1.1v-4.9 H828.8L828.8,59.9z M832.5,64.6c0.1,0.1,0.2,0.1,0.4,0.2c0.2,0.1,0.3,0.1,0.5,0.1c0.2,0,0.4,0,0.5,0c0.3,0,0.6,0,0.9-0.1 c0.2-0.1,0.5-0.2,0.6-0.3s0.3-0.3,0.4-0.5c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.4-0.5 s-0.4-0.3-0.7-0.4c-0.2-0.1-0.4-0.2-0.5-0.2s-0.2-0.1-0.3-0.2c-0.1-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.2s0.1-0.1,0.2-0.2 c0.1,0,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0.1,0.2,0.1l0.2-0.9c-0.1-0.1-0.3-0.1-0.5-0.2 s-0.5-0.1-0.7-0.1c-0.3,0-0.5,0-0.8,0.1c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.3,0.3-0.4,0.5c-0.1,0.2-0.1,0.4-0.1,0.6 c0,0.2,0.1,0.5,0.2,0.6s0.3,0.3,0.5,0.5c0.2,0.1,0.4,0.2,0.7,0.3c0.2,0.1,0.3,0.1,0.5,0.2s0.2,0.1,0.3,0.2 c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.2S834.1,64,834,64c-0.2,0-0.3,0-0.5,0 c-0.2,0-0.3-0.1-0.4-0.1s-0.2-0.1-0.3-0.2L832.5,64.6L832.5,64.6z M839.5,64.8h1.1v-4h1.3v-0.9h-3.8v0.9h1.3V64.8L839.5,64.8z  M844.3,64.8h1.1v-1.9h0.3c0.2,0,0.3,0,0.4,0.1s0.2,0.1,0.3,0.2s0.1,0.3,0.2,0.5c0.1,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.1,0.3,0.1,0.4 h1.1c0-0.1,0-0.1-0.1-0.2s-0.1-0.2-0.1-0.3s-0.1-0.3-0.1-0.4s-0.1-0.3-0.1-0.4c-0.1-0.2-0.1-0.4-0.2-0.6s-0.2-0.3-0.4-0.3v0 c0.1,0,0.2-0.1,0.3-0.2s0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.4-0.1-0.6 c-0.1-0.2-0.2-0.3-0.3-0.4c-0.2-0.1-0.4-0.2-0.7-0.3c-0.3-0.1-0.6-0.1-0.9-0.1c-0.3,0-0.6,0-0.8,0s-0.5,0-0.7,0.1L844.3,64.8 L844.3,64.8z M845.4,60.7c0,0,0.1,0,0.2,0s0.2,0,0.3,0c0.2,0,0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.3,0.2s0.1,0.2,0.1,0.4 c0,0.1,0,0.3-0.1,0.4s-0.2,0.2-0.3,0.2c-0.1,0.1-0.3,0.1-0.5,0.1h-0.4L845.4,60.7L845.4,60.7z M853.1,63.5l0.4,1.3h1.2l-1.5-4.9 h-1.5l-1.5,4.9h1.1l0.3-1.3L853.1,63.5L853.1,63.5z M851.8,62.7l0.3-1c0-0.1,0-0.2,0.1-0.3s0-0.2,0.1-0.3c0-0.1,0-0.2,0.1-0.3h0 c0,0.1,0,0.2,0.1,0.3s0,0.2,0.1,0.3s0.1,0.2,0.1,0.3l0.3,1H851.8L851.8,62.7z M857.1,64.8h1.1v-1.9h0.3c0.2,0,0.3,0,0.4,0.1 s0.2,0.1,0.3,0.2s0.1,0.3,0.2,0.5c0.1,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.1,0.3,0.1,0.4h1.1c0-0.1,0-0.1-0.1-0.2s-0.1-0.2-0.1-0.3 s-0.1-0.3-0.1-0.4s-0.1-0.3-0.1-0.4c-0.1-0.2-0.1-0.4-0.2-0.6s-0.2-0.3-0.4-0.3v0c0.1,0,0.2-0.1,0.3-0.2s0.2-0.2,0.3-0.3 c0.1-0.1,0.2-0.2,0.2-0.3c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.3-0.4c-0.2-0.1-0.4-0.2-0.7-0.3 c-0.3-0.1-0.6-0.1-0.9-0.1c-0.3,0-0.6,0-0.8,0s-0.5,0-0.7,0.1L857.1,64.8L857.1,64.8z M858.2,60.7c0,0,0.1,0,0.2,0s0.2,0,0.3,0 c0.2,0,0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.3,0.2s0.1,0.2,0.1,0.4c0,0.1,0,0.3-0.1,0.4s-0.2,0.2-0.3,0.2c-0.1,0.1-0.3,0.1-0.5,0.1h-0.4 L858.2,60.7L858.2,60.7z M866.2,61.8h-1.8v-1h1.9v-0.9h-3v4.9h3.1v-0.9h-2v-1.2h1.8L866.2,61.8L866.2,61.8z M872,59.9v4.9h1.1 v-4.9H872L872,59.9z M880.1,64.8h1.1l-0.3-4.9h-1.5l-0.5,1.6c-0.1,0.2-0.1,0.4-0.2,0.6c0,0.2-0.1,0.4-0.2,0.6 c0,0.2-0.1,0.4-0.1,0.6h0c0-0.3-0.1-0.6-0.2-0.9s-0.2-0.6-0.2-0.9l-0.5-1.6h-1.5l-0.3,4.9h1l0.1-1.9c0-0.2,0-0.4,0-0.7 c0-0.2,0-0.5,0-0.7s0-0.5,0-0.7h0c0,0.2,0.1,0.4,0.1,0.7c0,0.2,0.1,0.4,0.2,0.7s0.1,0.4,0.2,0.6l0.5,1.9h0.9l0.6-1.9 c0.1-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.1-0.4,0.2-0.7s0.1-0.4,0.2-0.6h0c0,0.2,0,0.5,0,0.7c0,0.2,0,0.5,0,0.7s0,0.4,0,0.6L880.1,64.8 L880.1,64.8z M886,59.8c-0.4,0-0.7,0.1-1,0.2c-0.3,0.1-0.5,0.3-0.8,0.5s-0.4,0.5-0.5,0.8s-0.2,0.7-0.2,1c0,0.3,0,0.5,0.1,0.8 c0.1,0.2,0.2,0.5,0.3,0.7c0.1,0.2,0.3,0.4,0.5,0.5c0.2,0.2,0.4,0.3,0.6,0.3s0.5,0.1,0.8,0.1c0.4,0,0.7-0.1,1-0.2s0.5-0.3,0.8-0.5 c0.2-0.2,0.4-0.5,0.5-0.8c0.1-0.3,0.2-0.7,0.2-1.1c0-0.3,0-0.5-0.1-0.8c-0.1-0.2-0.2-0.5-0.3-0.7s-0.3-0.4-0.5-0.5 c-0.2-0.2-0.4-0.3-0.7-0.3C886.6,59.8,886.3,59.8,886,59.8L886,59.8z M886,60.7c0.2,0,0.4,0,0.5,0.1s0.3,0.2,0.4,0.4 c0.1,0.2,0.2,0.3,0.2,0.5c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0,0.5-0.1,0.7s-0.1,0.4-0.2,0.5c-0.1,0.2-0.2,0.3-0.4,0.3 c-0.2,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.3,0-0.5-0.1c-0.2-0.1-0.3-0.2-0.4-0.3c-0.1-0.2-0.2-0.3-0.2-0.5s-0.1-0.4-0.1-0.7 s0-0.5,0.1-0.7s0.1-0.4,0.2-0.5c0.1-0.2,0.2-0.3,0.4-0.3C885.6,60.7,885.8,60.7,886,60.7L886,60.7z M890.9,64.8 c0.1,0,0.3,0,0.5,0.1s0.4,0,0.7,0c0.3,0,0.6,0,0.8-0.1c0.2,0,0.5-0.1,0.6-0.2c0.2-0.1,0.3-0.2,0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.3 c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.3-0.4c-0.2-0.1-0.3-0.2-0.5-0.2v0 c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.2-0.2,0.3-0.4s0.1-0.3,0.1-0.4c0-0.2,0-0.3-0.1-0.4s-0.1-0.2-0.2-0.3 c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.2-0.1-0.4-0.2c-0.1,0-0.3-0.1-0.5-0.1s-0.4,0-0.6,0c-0.2,0-0.4,0-0.5,0s-0.3,0-0.5,0 s-0.3,0-0.4,0L890.9,64.8L890.9,64.8z M892,60.7c0,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0c0.2,0,0.5,0,0.6,0.1c0.1,0.1,0.2,0.2,0.2,0.4 c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.2-0.3,0.2s-0.3,0.1-0.5,0.1H892L892,60.7L892,60.7z M892,62.6h0.4c0.1,0,0.3,0,0.4,0 c0.1,0,0.2,0.1,0.3,0.1s0.2,0.1,0.2,0.2c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3s-0.1,0.2-0.2,0.2s-0.2,0.1-0.3,0.1 c-0.1,0-0.2,0-0.4,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.2,0L892,62.6L892,62.6z M897.1,59.9v4.9h1.1v-4.9H897.1L897.1,59.9z  M901,64.8h3v-0.9h-2v-4H901V64.8L901,64.8z M909.5,61.8h-1.8v-1h1.9v-0.9h-3v4.9h3.1v-0.9h-2v-1.2h1.8L909.5,61.8L909.5,61.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M169.6,680.5c0,2.1,0,4.3,0,6.4c-4.3,0-8.5,0-12.8,0c0-1.1,0-2.1,0-3.2c2.1,0,4.2,0,6.4,0c0-1.1,0-2.1,0-3.2 c-2.1,0-4.2,0-6.4,0c0-1,0-2.1,0-3.2c-1.1,0-2.1,0-3.1,0c0,1.1,0,2.1,0,3.1c1.1,0,2.1,0,3.2,0c0,1.1,0,2.2,0,3.2 c-2.1,0-4.2,0-6.4,0c0-1.1,0-2.1,0-3.2c-1.1,0-2.1,0-3.1,0c0-3.2,0-6.4,0-9.6c2.1,0,4.2,0,6.3,0c0-3.2,0-6.4,0-9.5 c-3.2,0-6.4,0-9.6,0c0,5.3,0,10.6,0,16c-1.1,0-2.1,0-3.2,0c0,1.1,0,2.1,0,3.1c-1.1,0-2.1,0-3.2,0c0-1.1,0-2.1,0-3.2 c-3.2,0-6.4,0-9.6,0c0-1.1,0-2.1,0-3.2c-1.1,0-2.2,0-3.2,0c0-1.1,0-2.1,0-3.2c-1.1,0-2.1,0-3.2,0c0-5.4,0-10.7,0-16 c-1.1,0-2.1,0-3.2,0l0,0c0-1.1,0-2.1,0-3.2c-1.1,0-2.2,0-3.2,0l0,0c0-1.1,0-2.2,0-3.2l0,0c1.1,0,2.1,0,3.2,0c0-1.1,0-2.2,0-3.2 c2.2,0,4.3,0,6.4,0c0,2.1,0,4.2,0,6.4c2.2,0,4.3,0,6.4,0c0-1.1,0-2.1,0-3.2c-1.1,0-2.1,0-3.2,0c0-1.1,0-2.1,0-3.2 c-1.1,0-2.2,0-3.2,0c0-3.2,0-6.4,0-9.5c1.1,0,2.2,0,3.2,0c0,2.1,0,4.2,0,6.4c1.1,0,2.1,0,3.2,0c0,1.1,0,2.1,0,3.2 c1.1,0,2.1,0,3.2,0c0,3.2,0,6.4,0,9.6c-1.1,0-2.1,0-3.2,0c0,2.2,0,4.3,0,6.3c1.1,0,2.1,0,3.1,0c0-2.2,0-4.3,0-6.4 c2.1,0,4.2,0,6.4,0c0-1.1,0-2.2,0-3.2c1.1,0,2.1,0,3.2,0l0,0c0,2.1,0,4.2,0,6.4c4.3,0,8.5,0,12.8,0c0,1.1,0,2.1,0,3.2 c2.2,0,4.3,0,6.4,0l0,0c0,1.1,0,2.1,0,3.2c2.2,0,4.3,0,6.4,0c0,4.3,0,8.5,0,12.8c-1.1,0-2.1,0-3.1,0c0,1.1,0,2.1,0,3.2 C167.5,680.5,168.6,680.5,169.6,680.5z M163.2,674.1c1.1,0,2.1,0,3.2,0c0-1.1,0-2.1,0-3.2c-1.1,0-2.1,0-3.2,0c0-1.1,0-2.1,0-3.2 c-1.1,0-2.1,0-3.2,0c0-1.1,0-2.1,0-3.1c-1.1,0-2.1,0-3.1,0c0,3.2,0,6.4,0,9.5c1.1,0,2.1,0,3.2,0c0,1,0,2.1,0,3.2 c1.1,0,2.1,0,3.2,0C163.2,676.2,163.2,675.1,163.2,674.1z M128,667.7c0-2.1,0-4.2,0-6.4c-1.1,0-2.1,0-3.1,0c0,2.1,0,4.2,0,6.4 C125.9,667.7,127,667.7,128,667.7c0,1,0,2.1,0,3.2c1.1,0,2.1,0,3.2,0c0,1.1,0,2.1,0,3.1c3.2,0,6.4,0,9.6,0c0-3.2,0-6.3,0-9.5 c-1.1,0-2.1,0-3.2,0c0,2.1,0,4.2,0,6.3c-1.1,0-2.1,0-3.2,0c0-2.1,0-4.2,0-6.3c-1.1,0-2.1,0-3.2,0c0,1.1,0,2.1,0,3.2 C130.1,667.7,129,667.7,128,667.7z M124.8,658c1.1,0,2.1,0,3.1,0c0-1.1,0-2.1,0-3.1c-1.1,0-2.1,0-3.1,0 C124.8,656,124.8,657,124.8,658z M140.8,661.3c0-1.1,0-2.1,0-3.1c-1.1,0-2.1,0-3.1,0c0,1.1,0,2.1,0,3.1 C138.7,661.3,139.7,661.3,140.8,661.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.4,619.7c-1,0-2.1,0-3.2,0c0-4.3,0-8.5,0-12.8c1.1,0,2.1,0,3.2,0c0,1,0,2.1,0,3.2c3.2,0,6.4,0,9.6,0 c0-1.1,0-2.1,0-3.2c2.1,0,4.3,0,6.4,0c0,1.1,0,2.1,0,3.2c2.2,0,4.3,0,6.4,0c0,2.2,0,4.2,0,6.3c1.1,0,2.1,0,3.2,0 c0-3.2,0-6.4,0-9.5c8.5,0,17.1,0,25.6,0c0,7.5,0,14.9,0,22.4c-7.4,0-14.9,0-22.4,0c0-2.2,0-4.2,0-6.4c-1.1,0-2.1,0-3.1,0 c0,3.2,0,6.4,0,9.6c1.1,0,2.1,0,3.1,0c0,1.1,0,2.1,0,3.2c-1.1,0-2.1,0-3.1,0c0,1.1,0,2.1,0,3.2c1.1,0,2.1,0,3.2,0 c0,1.1,0,2.2,0,3.2l0,0c-3.2,0-6.4,0-9.6,0c0-1.1,0-2.1,0-3.2c1,0,2,0,3.1,0c0-3.2,0-6.4,0-9.6c-2.1,0-4.2,0-6.3,0 c0,3.2,0,6.3,0,9.5c-1.1,0-2.1,0-3.2,0c0-3.2,0-6.3,0-9.5c-1.1,0-2.1,0-3.2,0c0-1.1,0-2.2,0-3.2l0,0c1.1,0,2.1,0,3.2,0 c0-1.1,0-2.2,0-3.2c1.1,0,2.1,0,3.2,0c0-2.2,0-4.3,0-6.4c1.1,0,2.1,0,3.2,0c0-1.1,0-2.1,0-3.2c-1.1,0-2.1,0-3.1,0 c0,1.1,0,2.1,0,3.2c-1.1,0-2.1,0-3.2,0c0-1.1,0-2.2,0-3.2c-1.1,0-2.1,0-3.2,0c0,2.2,0,4.3,0,6.4c-1.1,0-2.2,0-3.2,0l0,0 c0-1.1,0-2.1,0-3.2c-1.1,0-2.2,0-3.2,0c0-1.1,0-2.1,0-3.1c-1.1,0-2.1,0-3.2,0C118.4,615.5,118.4,617.6,118.4,619.7L118.4,619.7z  M166.4,626.1c0-5.3,0-10.6,0-15.9c-5.3,0-10.6,0-15.9,0c0,5.3,0,10.6,0,15.9C155.8,626.1,161,626.1,166.4,626.1z M137.6,626 c1.1,0,2.1,0,3.1,0c0-1.1,0-2.1,0-3.1c-1.1,0-2.1,0-3.1,0C137.6,624,137.6,625,137.6,626z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8,642.1c0,1,0,2.1,0,3.2c2.1,0,4.2,0,6.4,0c0,1.1,0,2.2,0,3.2l0,0c-2.1,0-4.2,0-6.4,0c0,1.1,0,2.2,0,3.2 c2.2,0,4.3,0,6.4,0l0,0c0,1.1,0,2.1,0,3.2c1.1,0,2.2,0,3.2,0l0,0c0,2.1,0,4.2,0,6.4c-1.1,0-2.1,0-3.2,0c0-1.1,0-2.1,0-3.2 c-1.1,0-2.2,0-3.2,0c0-1,0-2.1,0-3.2c-1.1,0-2.1,0-3.1,0c0,1.1,0,2.1,0,3.2c1.1,0,2.1,0,3.2,0c0,1.1,0,2.1,0,3.2 c-3.3,0-6.4,0-9.6,0c0-2.2,0-4.3,0-6.4c1.1,0,2.1,0,3.2,0c0-1.1,0-2.1,0-3.1c-1.1,0-2.1,0-3.2,0c0,1.1,0,2.1,0,3.2 c-1.1,0-2.1,0-3.2,0c0,2.2,0,4.3,0,6.3c-1.1,0-2.1,0-3.2,0c0-2.1,0-4.2,0-6.3c-1.1,0-2.2,0-3.2,0c0-3.2,0-6.4,0-9.6 c1.1,0,2.2,0,3.2,0c0-1.1,0-2.1,0-3.2c-2.2,0-4.2,0-6.4,0c0-3.2,0-6.4,0-9.6c4.2,0,8.5,0,12.8,0c0,1.1,0,2.1,0,3.2 c-3.2,0-6.3,0-9.5,0c0,1.1,0,2.1,0,3.2c4.2,0,8.4,0,12.8,0c0,1.1,0,2.2,0,3.2c-2.1,0-4.2,0-6.4,0c0,1.1,0,2.1,0,3.2 c2.1,0,4.2,0,6.3,0c0-1.1,0-2.1,0-3.2C106.7,642.1,107.8,642.1,108.8,642.1L108.8,642.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,648.5c1,0,2.1,0,3.2,0c0-2.2,0-4.3,0-6.4l0,0c1.1,0,2.1,0,3.2,0c0,1.1,0,2.1,0,3.1c2.2,0,4.2,0,6.4,0 c0-2.2,0-4.3,0-6.4l0,0c3.2,0,6.4,0,9.6,0c0-2.2,0-4.3,0-6.4c1.1,0,2.1,0,3.2,0c0,6.4,0,12.8,0,19.2c-1.1,0-2.1,0-3.2,0l0,0 c0-1,0-2.1,0-3.2c-1.1,0-2.2,0-3.2,0c0-1.1,0-2.2,0-3.3c1.1,0,2.1,0,3.2,0c0-1.1,0-2.1,0-3.1c-1.1,0-2.1,0-3.2,0 c0,1.1,0,2.1,0,3.2c-1.1,0-2.1,0-3.2,0c0,1.1,0,2.1,0,3.2c1.1,0,2.1,0,3.1,0c0,1.1,0,2.1,0,3.2l0,0c-1.1,0-2.1,0-3.2,0 c0,1.1,0,2.2,0,3.2c-3.2,0-6.4,0-9.6,0c0-1.1,0-2.1,0-3.2c-2.2,0-4.3,0-6.4,0l0,0C144,650.6,144,649.6,144,648.5z M156.8,648.5 c-1.1,0-2.1,0-3.1,0c0,1.1,0,2.1,0,3.1c1.1,0,2.1,0,3.1,0C156.8,650.6,156.8,649.6,156.8,648.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,606.9c0,7.4,0,14.9,0,22.4c-7.5,0-14.9,0-22.4,0c0-7.5,0-14.9,0-22.4C97.1,606.9,104.5,606.9,112,606.9z M92.8,626 c5.3,0,10.6,0,15.9,0c0-5.3,0-10.6,0-15.9c-5.3,0-10.6,0-15.9,0C92.8,615.5,92.8,620.7,92.8,626z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6,664.5c7.4,0,14.9,0,22.4,0c0,7.5,0,15,0,22.4c-7.5,0-14.9,0-22.4,0C89.6,679.4,89.6,672,89.6,664.5z M108.8,667.7 c-5.3,0-10.6,0-15.9,0c0,5.3,0,10.6,0,15.9c5.3,0,10.6,0,15.9,0C108.8,678.3,108.8,673.1,108.8,667.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8,674.1c0,2.1,0,4.2,0,6.4c3.2,0,6.4,0,9.6,0c0,1.1,0,2.1,0,3.2c-1,0-2,0-3.2,0c0,1.1,0,2.2,0,3.2 c-1.1,0-2.1,0-3.2,0c0-1,0-2.1,0-3.2c-1.1,0-2.1,0-3.2,0c0,1.1,0,2.1,0,3.2c-1.1,0-2.1,0-3.2,0c0-1,0-2.1,0-3.2 c-1.1,0-2.2,0-3.2,0l0,0c0-1,0-2.1,0-3.2c-1.1,0-2.1,0-3.2,0c0-3.2,0-6.4,0-9.6c1,0,2.1,0,3.1,0c0,1,0,2,0,3.2 C120.6,674.1,122.7,674.1,124.8,674.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.6,654.9c0,1.1,0,2.1,0,3.2c-1.1,0-2.1,0-3.2,0c0,1.1,0,2.1,0,3.2c-1.1,0-2.1,0-3.2,0l0,0c0-3.2,0-6.4,0-9.6l0,0 c1.1,0,2.1,0,3.2,0l0,0c0,1.1,0,2.1,0,3.2C167.5,654.9,168.6,654.9,169.6,654.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6,654.9c1.1,0,2.1,0,3.2,0c0,1,0,2.1,0,3.2c-1.1,0-2.2,0-3.2,0C89.6,657,89.6,656,89.6,654.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.2,686.9c0-1,0-2.1,0-3.2c1.1,0,2.2,0,3.2,0l0,0c0,1.1,0,2.1,0,3.2C117.3,686.9,116.3,686.9,115.2,686.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,626.1c-1,0-2.1,0-3.2,0c0,2.1,0,4.2,0,6.4c-1.1,0-2.1,0-3.2,0c0-3.2,0-6.3,0-9.5c-1.1,0-2.1,0-3.2,0 c0-1.1,0-2.2,0-3.2l0,0c2.1,0,4.3,0,6.4,0l0,0c0,1.1,0,2.1,0,3.2c1.1,0,2.2,0,3.2,0C128,624,128,625,128,626.1L128,626.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,648.5c-1,0-2.1,0-3.2,0c0,1.1,0,2.1,0,3.2c-1,0-2.1,0-3.2,0c0-2.2,0-4.2,0-6.4c2.1,0,4.2,0,6.4,0 C144,646.4,144,647.5,144,648.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.2,632.5c0,1,0,2.1,0,3.2c-2.1,0-4.2,0-6.3,0c0-1,0-2,0-3.1C111,632.5,113.1,632.5,115.2,632.5L115.2,632.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8,642.1c0-1,0-2.1,0-3.2c1.1,0,2.1,0,3.2,0c0,1,0,2,0,3.1C110.9,642.1,109.8,642.1,108.8,642.1L108.8,642.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.4,635.7c1,0,2.1,0,3.1,0c0,1,0,2,0,3.1c-1,0-2,0-3.1,0C118.4,637.8,118.4,636.8,118.4,635.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.2,632.5c0-1,0-2.1,0-3.2c1.1,0,2.1,0,3.2,0c0,1,0,2,0,3.2C117.3,632.5,116.2,632.5,115.2,632.5 C115.2,632.5,115.2,632.5,115.2,632.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.2,667.6c0-1,0-2,0-3.1c1,0,2.1,0,3.1,0c0,1,0,2,0,3.1C117.3,667.6,116.3,667.6,115.2,667.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.2,664.5c1,0,2,0,3.1,0c0,1,0,2.1,0,3.1c-1,0-2,0-3.1,0C147.2,666.6,147.2,665.6,147.2,664.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.8,638.9c-2.1,0-4.2,0-6.4,0c0-1.1,0-2.1,0-3.2c1,0,2,0,3.1,0c0-1.1,0-2.1,0-3.2c3.2,0,6.4,0,9.6,0c0,1,0,2,0,3.1 c-2.1,0-4.2,0-6.4,0C156.8,636.8,156.8,637.9,156.8,638.9C156.8,638.9,156.8,638.9,156.8,638.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,674.1c-1.1,0-2.1,0-3.2,0c0-1,0-2.1,0-3.2c1.1,0,2.2,0,3.2,0C163.2,672,163.2,673,163.2,674.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.6,622.8c0-3.2,0-6.3,0-9.5c3.2,0,6.3,0,9.5,0c0,3.2,0,6.3,0,9.5C160,622.8,156.8,622.8,153.6,622.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,622.9c0-1.1,0-2.2,0-3.2c1,0,2.1,0,3.2,0c0,1.1,0,2.2,0,3.2C130.1,622.9,129.1,622.9,128,622.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,622.8c0-3.2,0-6.3,0-9.5c3.2,0,6.3,0,9.5,0c0,3.2,0,6.3,0,9.5C102.4,622.8,99.2,622.8,96,622.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.6,670.9c0,3.2,0,6.3,0,9.5c-3.2,0-6.3,0-9.5,0c0-3.2,0-6.3,0-9.5C99.2,670.9,102.4,670.9,105.6,670.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactura);
export default __webpack_public_path__ + "static/media/factura.a32c31015a2eb8e8c96412b28c795abc.svg";
export { ForwardRef as ReactComponent };